import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import CopyrightTwoToneSvg from "@ant-design/icons-svg/es/asn/CopyrightTwoTone";
import AntdIcon from "../components/AntdIcon";
var CopyrightTwoTone = function CopyrightTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CopyrightTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  CopyrightTwoTone.displayName = 'CopyrightTwoTone';
}
export default /*#__PURE__*/React.forwardRef(CopyrightTwoTone);